/* ─────────────────────────────────────────────────────
   Mekeni — shared scroll coordinator
   Single requestAnimationFrame loop reading window.scrollY once per
   frame and broadcasting derived progress values (ip, p, navP) to any
   registered listeners. Both the Intro Frame and Header (and Hero)
   read from this instead of each registering their own `scroll`
   listener, so they stay perfectly in sync.

   Loaded before mekeni.js in layout/theme.liquid.
   ───────────────────────────────────────────────────── */
window.MekeniScroll = (function () {
  /* The intro/hero phases are derived purely from window.scrollY, so a
     restored scroll position (browser back/forward, editor reloads) would
     otherwise render the page mid-sequence instead of at Frame 1. Force a
     fresh load to start at the top. */
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  if (window.scrollY > 0) {
    window.scrollTo(0, 0);
  }

  var listeners = [];

  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }

  function compute() {
    var scrollY = window.scrollY;
    var vh = window.innerHeight;

    /* Intro fade progress — 0 → 1 over the intro's 200vh scroll budget (2 swipes) */
    var ip = clamp(scrollY / (vh * 2), 0, 1);

    /* Hero bottle progress — starts after the intro's 200vh is consumed,
       runs over innerHeight × 1.2 of additional scroll */
    var p = clamp((scrollY - vh * 2.0) / (vh * 1.2), 0, 1);

    /* Nav / copy entrance — last 75% of the bottle phase. Header,
       hero copy, and CTA all resolve together at the scroll climax,
       now starting noticeably earlier in the scroll. */
    var navP = clamp((p - 0.25) / 0.75, 0, 1);

    return { scrollY: scrollY, vh: vh, ip: ip, p: p, navP: navP };
  }

  var rafId = null;
  function tick() {
    var state = compute();
    for (var i = 0; i < listeners.length; i++) {
      listeners[i](state);
    }
    rafId = requestAnimationFrame(tick);
  }

  function subscribe(fn) {
    listeners.push(fn);
    /* Kick off the shared loop lazily on first subscriber */
    if (rafId === null) rafId = requestAnimationFrame(tick);
    /* Fire immediately once with current state so listeners don't wait
       a frame for initial layout */
    fn(compute());
    return function unsubscribe() {
      var idx = listeners.indexOf(fn);
      if (idx !== -1) listeners.splice(idx, 1);
    };
  }

  return { subscribe: subscribe, clamp: clamp, lerp: lerp };
})();
